import { StorageService } from './services/storage.service';
import { NgModule } from '@angular/core';
@NgModule({
  providers: [
    StorageService,
  ],
})
export class SingletonModule {
}
